import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const SearchBarGqlApi = createApi({
  reducerPath: "searchBarGqlApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getSearchBarGqlApi: builder.query({
      query: (data: string): any => ({
        url: "/graphql",
        body: gql`query{
          globalSearch(requestDto: {
            searchRequest: "${data}",
            indices: ["tms", "content"],
            filters: null
        }
          ,pageNumber: 1, pageSize: 2000 sortKey: "_score", sortOrder: "DESC", relevance: true){
            timestamp
            error
            version
            data{
              totalCount
              pageSize
              pageNumber
              searchResult{
            id
            artifacttype
            artifacturl
            title
            shortdescription  
            brandingurls{
              thumbnail
            }   
              }
            }
          }
        }`
      }),
      extraOptions: { service: "Catalog" }
    })
  })
});

export const { useLazyGetSearchBarGqlApiQuery } = SearchBarGqlApi;
